import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busrentalforajantaellora() {



const cardData =
{
  keyword: 'Bus Rental for Ajanta Ellora',
  heading: 'Sanavi Travels: Bus Rental for Ajanta Ellora',
  headingDescription: 'Sanavi Travels offers reliable and well-planned bus rental for Ajanta Ellora, perfect for families, tourists, corporate groups, school excursions, and heritage lovers seeking a comfortable, safe, and organized group journey to India’s world-famous cave monuments.',

  top: 'Top Experiences & Places to Explore at Ajanta Ellora',

  topPlaces: [
    {
      title: 'Ajanta Caves – UNESCO World Heritage Site',
      description: 'Ajanta Caves are among the most remarkable ancient rock-cut cave monuments in the world, known for their exquisite Buddhist murals, sculptures, and fresco paintings dating back to the 2nd century BCE. Traveling by rented bus to Ajanta allows groups to enjoy a relaxed and educational journey together, avoiding coordination issues of multiple vehicles. School groups, historians, photographers, and families benefit from organized travel, timely arrivals, and sufficient rest during the long route. The bus journey becomes an extension of the learning experience, with guides explaining history en route.'
    },
    {
      title: 'Ellora Caves – Kailasa Temple',
      description: 'Ellora Caves showcase a unique blend of Buddhist, Hindu, and Jain architecture, with the Kailasa Temple standing as an engineering marvel carved from a single rock. Group bus travel ensures everyone reaches the site together, making guided tours easier to manage. The spacious and comfortable ride is especially valuable for senior citizens and international tourists exploring this vast complex.'
    },
    {
      title: 'Heritage & Cultural Exploration',
      description: 'Ajanta and Ellora represent India’s rich cultural and spiritual heritage. Traveling by bus supports structured itineraries, allowing groups to explore each cave cluster calmly without rushing. It enhances focus on history, architecture, and cultural storytelling.'
    },
    {
      title: 'Educational & School Study Tours',
      description: 'Educational institutions regularly organize trips to Ajanta Ellora for history and art studies. Bus rentals help teachers supervise students effectively, maintain discipline, and ensure safety throughout the journey.'
    },
    {
      title: 'Corporate Cultural Offsites',
      description: 'Corporate groups choose Ajanta Ellora for cultural offsites and team learning experiences. Bus travel ensures punctual schedules, professional coordination, and comfortable long-distance travel.'
    },
    {
      title: 'Family Heritage Vacations',
      description: 'Families visiting Ajanta Ellora enjoy stress-free travel with enough space for elders, children, and luggage. A single bus keeps the family together, strengthening shared travel memories.'
    },
    {
      title: 'Photography & Art Tours',
      description: 'Photographers and art enthusiasts prefer early departures and planned schedules. Bus rentals make it easy to coordinate timings and equipment transport.'
    },
    {
      title: 'Weekend & Multi-Day Tours',
      description: 'Ajanta Ellora tours often span multiple days. Outstation-ready buses provide comfort, reliable performance, and sufficient storage for overnight travel.'
    },
    {
      title: 'Pilgrimage & Spiritual Study Trips',
      description: 'Many spiritual groups combine Ajanta Ellora visits with nearby religious sites. Bus travel supports multi-destination planning efficiently.'
    },
    {
      title: 'Eco-Friendly Group Travel',
      description: 'Group bus travel reduces the number of vehicles, supports sustainable tourism, and aligns with responsible heritage conservation practices.'
    }
  ],

  services: [
    {
      name: 'Bus Rental for Ajanta Ellora',
      description: 'Sanavi Travels provides dedicated bus rental services for Ajanta Ellora with a focus on comfort, safety, and heritage-friendly travel. Our buses are ideal for long-distance journeys, offering spacious seating, smooth suspension, ample luggage space, and experienced drivers. Families, schools, corporate groups, and tourists benefit from organized travel, transparent pricing, and reliable scheduling.'
    },
    {
      name: 'AC Bus for Ajanta Ellora',
      description: 'AC buses ensure a cool and relaxed environment during long travel hours, especially suitable for senior citizens and international tourists.'
    },
    {
      name: 'Non AC Bus Hire Ajanta Ellora',
      description: 'Non-AC buses offer economical solutions for large groups without compromising safety or seating comfort.'
    },
    {
      name: 'Luxury Bus Rental Ajanta Ellora',
      description: 'Luxury buses feature premium interiors, ideal for VIP guests, corporate delegations, and high-end tour groups.'
    },
    {
      name: 'Mini Bus on Rent Ajanta Ellora',
      description: 'Mini buses are perfect for smaller family groups and private tours, offering flexibility and comfort.'
    },
    {
      name: '32 Seater Bus Ajanta Ellora',
      description: '32 seater buses suit medium-sized groups such as schools, colleges, and corporate teams.'
    },
    {
      name: '35 Seater Bus Hire Ajanta Ellora',
      description: '35 seater buses accommodate large groups efficiently, ideal for educational and tourist tours.'
    },
    {
      name: 'Bus for Family Ajanta Ellora',
      description: 'Family-friendly buses ensure smooth travel for all age groups with comfortable seating and safe driving.'
    },
    {
      name: 'Bus for Corporate Ajanta Ellora',
      description: 'Corporate bus services support professional travel planning, punctual departures, and organized group movement.'
    },
    {
      name: 'Affordable Bus Rental Ajanta Ellora',
      description: 'Budget-friendly pricing options help groups manage travel costs without sacrificing reliability.'
    },
    {
      name: 'Best Bus Service Ajanta Ellora',
      description: 'Sanavi Travels is known for dependable service, trained drivers, and high customer satisfaction.'
    },
    {
      name: 'Bus with Driver Ajanta Ellora',
      description: 'All buses include licensed drivers experienced with long-distance and heritage routes.'
    },
    {
      name: 'Bus for Wedding Ajanta Ellora',
      description: 'Wedding and family event transport services ensure organized guest movement for destination functions.'
    },
    {
      name: 'Bus for Picnic Ajanta Ellora',
      description: 'Picnic-focused buses provide relaxed group travel with sufficient seating and luggage capacity.'
    },
    {
      name: 'Outstation Bus Ajanta Ellora',
      description: 'Outstation-ready buses ensure safe, comfortable, and reliable long-distance travel.'
    }
  ],

  tableData: [
    ['AC Bus', 'Non AC Bus'],
    ['Mini Bus', 'Luxury Bus'],
    ['Family Tour', 'Corporate Tour'],
    ['School Trip', 'Heritage Tour'],
    ['Affordable', 'Premium Options']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Experienced Long-Distance Drivers',
      WhyChoosedescription: 'Our drivers are trained for long routes and heritage destinations, ensuring safe and smooth journeys.'
    },
    {
      WhyChooseheading: 'Comfortable & Maintained Fleet',
      WhyChoosedescription: 'Regular maintenance and cleanliness checks guarantee comfort and reliability.'
    },
    {
      WhyChooseheading: 'Multiple Bus Options',
      WhyChoosedescription: 'Choose from mini, 32 seater, and 35 seater buses based on group size.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'No hidden charges, complete pricing clarity for stress-free planning.'
    },
    {
      WhyChooseheading: 'Safe & Sanitized Vehicles',
      WhyChoosedescription: 'Buses are sanitized and safety-checked before every trip.'
    },
    {
      WhyChooseheading: 'Flexible Pickup & Scheduling',
      WhyChoosedescription: 'Custom pickup points and travel timings available.'
    },
    {
      WhyChooseheading: 'Ideal for Heritage & Educational Tours',
      WhyChoosedescription: 'Services designed specifically for long heritage explorations.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Support team assists from booking to journey completion.'
    }
  ]
};

const faqData = [
  { question: 'Do you provide bus rental for Ajanta Ellora?', answer: 'Yes, we provide AC and Non-AC bus rentals for Ajanta Ellora tours.' },
  { question: 'Is this suitable for school trips?', answer: 'Yes, schools and colleges frequently book our buses for educational tours.' },
  { question: 'Are AC buses available?', answer: 'Yes, AC buses are available for added comfort.' },
  { question: 'Are drivers experienced with long routes?', answer: 'Yes, our drivers are trained for long-distance travel.' },
  { question: 'Can families book private buses?', answer: 'Yes, family and private group bookings are available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, especially during tourist seasons and holidays.' },
  { question: 'Are buses sanitized?', answer: 'Yes, all buses are sanitized before departure.' },
  { question: 'Is pricing transparent?', answer: 'Yes, we follow clear and transparent pricing policies.' },
  { question: 'Do you allow custom pickup points?', answer: 'Yes, pickup locations can be customized.' },
  { question: 'Is customer support available?', answer: 'Yes, 24/7 customer support is provided.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Joshi',
    feedback: 'We booked a bus from Sanavi Travels for an Ajanta Ellora heritage tour with our family group. The journey was smooth, comfortable, and very well managed. The driver was experienced and courteous, making the long trip enjoyable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshpande',
    feedback: 'Our college arranged an educational trip to Ajanta Ellora using Sanavi Travels. The bus was clean, punctual, and spacious. Traveling together made coordination easy and the overall experience excellent.',
    rating: 5
  }
];

































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental for Ajanta Ellora - Sanavi Travels",
  "description": "Sanavi Travels offers bus rental services for Ajanta Ellora trips, including AC and Non-AC buses, luxury buses, 32-seater, 35-seater, and mini bus options. Ideal for family tours, corporate travel, weddings, picnics, sightseeing, and outstation journeys with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Rental for Ajanta Ellora | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for Ajanta Ellora trips with Sanavi Travels. AC & Non-AC buses, luxury buses, 32-seater, 35-seater, and mini bus options for family tours, corporate travel, weddings, picnics, sightseeing, and outstation journeys with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/302.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busrentalforajantaellora;